import React from 'react';
import { Select, MenuItem, Box } from '@mui/material';
import { makeStyles } from '@mui/styles';
import classNames from 'classnames';

import useQuestion from './useQuestion';

const useStyles = makeStyles((theme) => {
    return {
        select: {
            '&.MuiOutlinedInput-root': {
                borderRadius: '8px',
            },
        },
        readOnlySelect: {
            '& > .MuiSelect-outlined': {
                backgroundColor: '#EFEFEF',
                color: '#586874',
                fontSize: '15px',
                '-webkit-text-fill-color': 'unset',
                outline: 'none',
            },
        },
        readOnlyItem: {
            '&.Mui-disabled': {
                color: '#586874',
                fontSize: '15px',
                '-webkit-text-fill-color': 'unset',
                outline: 'none',
                '&.Mui-selected': {
                    backgroundColor: '#EFEFEF',
                    fontWeight: 450,
                    opacity: 1,
                },
            },
        },
    };
});

const DropdownMultiple = (props) => {
    const { question, disabled, readOnly } = props;

    const { chosenVal, handleOptionChange } = useQuestion(question);

    const classes = useStyles();

    //#TODO TechDebt - This Component has only had a readOnly state implemented so far. It's full functionality will be implemented after the TSB project.
    return (
        <Box>
            <Select
                size="small"
                sx={{ width: 400 }}
                value={chosenVal}
                onChange={(event) => handleOptionChange(event.target.value)}
                className={classNames({
                    [classes.select]: true,
                    [classes.readOnlySelect]: readOnly,
                })}
                multiple
            >
                {question.options.map((opt) => {
                    return (
                        <MenuItem
                            key={`question-${question.id}-opt-${opt.id}`}
                            value={opt.id}
                            disabled={disabled || readOnly}
                            className={classNames({
                                [classes.readOnlyItem]: readOnly,
                            })}
                        >
                            {opt.text['en-US']}
                        </MenuItem>
                    );
                })}
            </Select>
        </Box>
    );
};

export default DropdownMultiple;
